
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/appManager/components/ProgressRing/ProgressRing.scss.css.virtualfile';
        module.exports = {"container":"_container_qq97a_7","ring":"_ring_qq97a_15","track":"_track_qq97a_22","progress":"_progress_qq97a_26"};